<template>
  <b-form @submit="submitAdress">
    <loading :active.sync="is_loading"></loading>
    <div class="form-group row">
      <div class="col-md-12">
        <label class="text-black"
          >Campos obligatorios <span class="text-danger">*</span></label
        >
        <label
          >Los cambios de dirección serán efectuados antes del corte mensual: 20
          de cada mes.
        </label>
      </div>
    </div>
    <b-form-group>
      <b-form-input
        v-model="address.cp"
        type="number"
        placeholder="Código postal"
        required
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <b-form-select v-model="address.state_id">
        <b-form-select-option value="" disabled
          >Selecciona Estado</b-form-select-option
        >
        <b-form-select-option
          v-for="state in states"
          :value="state.id"
          :key="state.id"
          >{{ state.name }}</b-form-select-option
        >
      </b-form-select>
    </b-form-group>
    <b-form-group>
      <b-form-select v-model="address.suburb" required>
        <b-form-select-option value="" disabled
          >Selecciona Colonia o Asentamiento</b-form-select-option
        >
        <b-form-select-option
          v-for="suburb in suburbs"
          :value="suburb.d_asenta"
          :key="suburb.d_asenta"
          >{{ suburb.d_asenta }}</b-form-select-option
        >
      </b-form-select>
    </b-form-group>
    <b-form-group>
      <b-form-input
        v-model="address.municipality"
        type="text"
        placeholder="Delegacion o Municipio"
        required
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <b-form-input
        v-model="address.street"
        type="text"
        placeholder="Calle"
        required
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <b-form-input
        v-model="address.no_int"
        type="text"
        placeholder="Número interior"
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <b-form-input
        v-model="address.no_ext"
        type="text"
        placeholder="Número exterior"
        required
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <b-form-input
        v-model="address.btw_streets"
        type="text"
        placeholder="Entre calles"
        required
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <b-form-input
        v-model="address.references"
        type="text"
        placeholder="Referencias"
        required
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <b-form-checkbox
        type="radio"
        id="customRadioInline1"
        name="customRadioInline1"
        v-model="address_type"
        value="1"
      >
        Para entregar en el buzón de tu casa
      </b-form-checkbox>
      <b-form-checkbox
        id="customRadioInline2"
        name="customRadioInline1"
        v-model="address_type"
        value="2"
      >
        Alguien deberá firmar de recibido
      </b-form-checkbox>
    </b-form-group>
    <button class="btn btn-blue btn-sm" type="submit">Guardar</button>
  </b-form>
</template>

<script>
import Loading from "vue-loading-overlay";
const axios = require("axios");
export default {
  name: "EditAddress",
  props: ["address", "hideForm"],
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      token_sepomex: process.env.VUE_APP_API_SEPOMEX_TOKEN,
      states: [],
      suburbs: [],
      is_loading: false,
      address_type: 2,
    };
  },
  components: {
    Loading,
  },
  created() {
    console.log(this.address);
    axios({
      method: "GET",
      url: this.api_url + "/cpssepomex/cp/" + this.address.cp,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + $cookies.get("utoken"),
      },
    })
      .then((response) => {
        this.suburbs = response.data;
      })
      .catch((error) => {
        console.error(error);
        this.$snotify.error("No hay información del CP");
      });
  },
  mounted() {
    if ($cookies.get("ctoken")) {
      this.getStates();
    }
  },
  watch: {
    "address.cp": function (newVal, oldVal) {
      if (newVal != undefined && newVal.length > 4) {
        axios({
          method: "GET",
          url: this.api_url + "/cpssepomex/cp/" + newVal,

          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("utoken"),
          },
        })
          .then((response) => {
            this.suburbs = response.data;
            // console.log(this.suburbs);
            this.address.suburb = this.suburbs[0].d_asenta;
            this.address.cp = this.suburbs[0].d_codigo;
            this.address.municipality = this.suburbs[0].d_mnpio;
            this.setAddressData(this.address);
          })
          .catch((error) => {
            console.error(error);
            this.$snotify.error("No hay información del CP");
          });
      }
    },
  },
  methods: {
    submitAdress(e) {
      e.preventDefault();
      this.is_loading = true;
      if ($cookies.get("ctoken")) {
        axios({
          method: "PUT",
          url: this.api_url + "/address/" + this.address.id,
          data: {
            subscriber_id: $cookies.get("uidmmkg"),
            state_id: this.address.state_id,
            cps_sepomex_id: 0,
            street: this.address.street,
            suburb: this.address.suburb,
            btw_streets: this.address.btw_streets,
            references: this.address.references,
            no_int: this.address.no_int,
            no_ext: this.address.no_ext,
            state: this.address.state,
            municipality: this.address.municipality,
            cp: this.address.cp,
            address_type_id: this.address_type,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("utoken"),
          },
        })
          .then((response) => {
            console.log(response);
            this.is_loading = false;
            this.$emit("hideForm", false);
            if (response.status) {
              this.$snotify.success("Se actualizó correctamente");
            } else {
              this.$snotify.warning("Hubo un error al actualizar la info");
            }
          })
          .catch((error) => {
            this.is_loading = false;
            console.error(error);
            this.$snotify.error(error);
          });
      }
    },
    getStates: function () {
      axios({
        method: "GET",
        url: this.api_url + "/state",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          this.states = response.data;
        })
        .catch((error) => {
          console.log("falloooo");
          console.error(error);
        });
    },
      setAddressData: function (data) {
          if (data) {
              this.$emit("update", data);
          } else {
              this.$emit("update", {});
          }
      },
  },
};
</script>

<style>
</style>